export default {
  advertisement: {
    id: 'product_page_trade_in_advertisement',
    defaultMessage: 'Get this for even less with Trade-in',
  },
}
